/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}`
 */
export interface DataRuleIdGetRequest {
  id: string;
}

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}`
 */
export interface DataRuleIdGetResponse {
  /**
   * 数值规则id
   */
  id?: number;
  /**
   * 状态
   */
  status?: 1 | 2;
  /**
   * 数值规则名称
   */
  name?: string;
  /**
   * 场景Id
   */
  sceneId?: number;
  /**
   * 场景名称
   */
  sceneName?: string;
  /**
   * 属性组Id
   */
  dataPropertyGroupId?: number;
  /**
   * 属性组名称
   */
  dataPropertyGroupName?: string;
  /**
   * 模板类型 1:数值型；2：解析型
   */
  type?: number;
  /**
   * 说明
   */
  detail?: string;
  /**
   * 步骤
   */
  step?: number;
  /**
   * 属性类型 0表示瞬时 1 表示累积
   */
  propertyType?: number;
  /**
   * 数据点周期
   */
  dataPointPeriod?: number;
  /**
   * 数据点间隔
   */
  dataPointInterval?: number;
  /**
   * 数据点数值,通过excel导入
   */
  uploadFileKey?: string;
  /**
   * 失败文件的key
   */
  errorFileKey?: string;
  /**
   * Y轴倍率名称
   */
  yMagnificationName?: string;
  /**
   * Y轴倍率默认值
   */
  yMagnificationValue?: number;
  /**
   * 瞬时量算累积量倍率
   */
  magnificationCumulative?: number;
  /**
   * 累积量起始值名称
   */
  cumulativeStartName?: string;
  /**
   * 累积量起始值默认值
   */
  cumulativeStartValue?: number;
  /**
   * excel导入的数据
   */
  excelData?: number[];
}

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}`
 */
type ApiDataRuleIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-rule/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}`
 */
const apiDataRuleIdGetRequestConfig: ApiDataRuleIdGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-rule/{id}',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataRuleIdGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}`
 */
export const apiDataRuleIdGet = /*#__PURE__*/ (requestData: DataRuleIdGetRequest, ...args: UserRequestRestArgs) => {
  return request<DataRuleIdGetResponse>(prepare(apiDataRuleIdGetRequestConfig, requestData), ...args);
};

apiDataRuleIdGet.requestConfig = apiDataRuleIdGetRequestConfig;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `DELETE /api/data-rule/{id}`
 */
export interface DataRuleIdDeleteRequest {
  id: string;
}

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `DELETE /api/data-rule/{id}`
 */
export interface DataRuleIdDeleteResponse {}

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `DELETE /api/data-rule/{id}`
 */
type ApiDataRuleIdDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-rule/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `DELETE /api/data-rule/{id}`
 */
const apiDataRuleIdDeleteRequestConfig: ApiDataRuleIdDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-rule/{id}',
  method: Method.DELETE,
  requestHeaders: {},
  requestBodyType: RequestBodyType.none,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataRuleIdDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `DELETE /api/data-rule/{id}`
 */
export const apiDataRuleIdDelete = /*#__PURE__*/ (
  requestData: DataRuleIdDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DataRuleIdDeleteResponse>(prepare(apiDataRuleIdDeleteRequestConfig, requestData), ...args);
};

apiDataRuleIdDelete.requestConfig = apiDataRuleIdDeleteRequestConfig;

/* prettier-ignore-end */
